import MuiImageList, { type ImageListProps as MuiImageListProps } from '@mui/material/ImageList'
import MuiImageListItem, { type ImageListItemProps as MuiImageListItemProps } from '@mui/material/ImageListItem'
import MuiImageListItemBar, {
  type ImageListItemBarProps as MuiImageListItemBarProps,
} from '@mui/material/ImageListItemBar'
import MuiMobileStepper, { type MobileStepperProps as MuiMobileStepperProps } from '@mui/material/MobileStepper'

//* IMAGE LIST
export const ImageList = MuiImageList
export type ImageListProps = MuiImageListProps

//* IMAGE LIST ITEM
export const ImageListItem = MuiImageListItem
export type ImageListItemProps = MuiImageListItemProps

//* IMAGE LIST ITEM BAR
export const ImageListItemBar = MuiImageListItemBar
export type ImageListItemBarProps = MuiImageListItemBarProps

//* MOBILE STEPPER
export const MobileStepper = MuiMobileStepper
export type MobileStepperProps = MuiMobileStepperProps
